var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "speed-dial-demo" }, [
    _c(
      "div",
      [
        _c("fu-speed-dial", {
          attrs: {
            id: "left",
            size: "big",
            direction: "left",
            items: _vm.items
          },
          on: { click: _vm.click }
        })
      ],
      1
    ),
    _c(
      "div",
      [
        _c("fu-speed-dial", {
          attrs: {
            id: "top",
            items: _vm.items,
            type: "success",
            icon: "el-icon-video-play",
            "active-icon": "el-icon-video-pause"
          },
          on: { click: _vm.click }
        })
      ],
      1
    ),
    _c(
      "div",
      [
        _c("fu-speed-dial", {
          attrs: {
            icon: "iconfont icon-money",
            id: "right",
            size: "medium",
            direction: "right",
            type: "warning",
            items: _vm.items
          },
          on: { click: _vm.click }
        })
      ],
      1
    ),
    _c(
      "div",
      [
        _c("fu-speed-dial", {
          attrs: {
            id: "bottom",
            size: "small",
            direction: "bottom",
            type: "danger",
            items: _vm.items
          },
          on: { click: _vm.click }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }